var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#C6DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 20.3333H29.8125V18.2381C29.8125 15.3467 27.4325 13 24.5 13C21.5675 13 19.1875 15.3467 19.1875 18.2381V20.3333H18.125C16.9509 20.3333 16 21.271 16 22.4286V32.9048C16 34.0624 16.9509 35 18.125 35H30.875C32.0491 35 33 34.0624 33 32.9048V22.4286C33 21.271 32.0491 20.3333 30.875 20.3333ZM24.5 29.7619C23.3259 29.7619 22.375 28.8243 22.375 27.6667C22.375 26.509 23.3259 25.5714 24.5 25.5714C25.6741 25.5714 26.625 26.509 26.625 27.6667C26.625 28.8243 25.6741 29.7619 24.5 29.7619ZM27.7938 20.3333H21.2062V18.2381C21.2062 16.4467 22.6831 14.9905 24.5 14.9905C26.3169 14.9905 27.7938 16.4467 27.7938 18.2381V20.3333Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.c76dfccf64f05750b85ff7a6aae75491.svg";
export { ForwardRef as ReactComponent };